import LegalbirdIoModal from "../../Modal/LegalbirdIoModal";
import ButtonLoading from "../../Button/ButtonLoading";
import React, { useState } from "react";
import ApiClient from "../../../services/ApiClient";

import { ProductUnion } from "../../../types/ProductUnion";

type LitigationResetModalProps = {
  product: ProductUnion;
  open: boolean;
  handleClose: Function;
  refreshPage?: Function;
};

function LitigationResetModal({ product, open, handleClose, refreshPage = () => {} }: LitigationResetModalProps) {
  const [isLoading, setIsLoading] = useState(false);

  const resetLitigationCase = async () => {
    setIsLoading(true);
    await ApiClient.post(
      "case_special_actions/" + product.productClassName + "/" + product.id + "/reset_litigation_advisory_case"
    );
    refreshPage();
    handleClose();
  };

  return (
    <LegalbirdIoModal
      handleClose={handleClose}
      open={open}
      title={"Fall zurücksetzen?"}
      submitButton={
        <ButtonLoading onClick={resetLitigationCase} color="primary" variant={"contained"} isLoading={isLoading}>
          Fall zurücksetzen
        </ButtonLoading>
      }
    >
      <p className={"center"}>
        Wollen Sie den Fall wirklich zurücksetzen? Damit kann die Mandantschaft eine Forderung durchsetzen oder
        abwehren. Die Mandantschaft wird darüber per Email informiert und muss seine Angaben vervollständigen.
      </p>
    </LegalbirdIoModal>
  );
}

export default LitigationResetModal;
